import BaseModelAPI from '../BaseModelAPI';

export default class PackagingTypeList extends BaseModelAPI {

	static entity = 'packagingtypelist'
	static entityName = 'packagingtype';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
